import { CommonModule } from '@angular/common';
import { Component, Inject, ViewChild, ViewContainerRef } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { State } from 'src/app/components/designer/models/state';
import { StepStateFormDialogData } from '../Models/step-state-form-dialog-data';
import { StepStateFormDialogResult } from '../Models/step-state-form-dialog-result';

@Component({
    selector: 'app-action-form-dialog',
    imports: [MatCardModule, FormsModule, MatFormFieldModule, MatButtonModule, MatInputModule, CommonModule, ReactiveFormsModule],
    templateUrl: './step-state-form-dialog.component.html',
    styleUrl: './step-state-form-dialog.component.scss'
})
export class StepStateFormDialogComponent {
    /**
     * Reference au container dans lequel est affiché les composants dynamiques.
     */
    @ViewChild('dynamicContainer', { read: ViewContainerRef })
    dynamicContainer!: ViewContainerRef;

    /**
     * Instance de l'état affichée dans le formulaire.
     */
    public item: State;

    /**
     * Titre de la boite de dialogue.
     */
    public title: string;

    /**
     * Formulaire.
     */
    public stateForm: FormGroup;

    /**
     * Constructeur.
     * @param dialogRef
     * @param data
     */
    constructor(
        public dialogRef: MatDialogRef<StepStateFormDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: StepStateFormDialogData
    ) {
        this.title = data.title;
        this.item = State.clone(data.item);

        this.stateForm = new FormGroup({
            name: new FormControl(''),
        });

        if (data.readonly) {
            this.stateForm.disable();
        }

        this.fillForm(this.item);
    }

    /**
     * Appellé lorsque l'utilisateur valide le formulaire.
     */
    onConfirm(): void {
        this.RetrieveValueFromForm();
        let result: StepStateFormDialogResult = { status: true, item: this.item };

        // Close the dialog, return true
        this.dialogRef.close(result);
    }

    /**
     * Appellé lorsque l'utilisateur annule le formulaire.
     */
    onCancel(): void {
        let result: StepStateFormDialogResult = { status: false, item: this.item };
        // Close the dialog, return false
        this.dialogRef.close(result);
    }

    /**
     * Remplit les champs du formulaire avec les données de l'état.
     */
    private fillForm(item: State) {
        this.stateForm.get('name').setValue(item.name);
    }

    /**
     * Retourne les données de l'état à partir des champs du formulaire.
     */
    private RetrieveValueFromForm() {
        this.item.name = this.stateForm.get('name').value;
    }
}
